module.exports = [
	{
		"id": "employment-select",
		"name": "Please select...",
		"value": "",
		"subCategories": []
	},
	{
		"id": "employment-employed",
		"name": "Employed",
		"value": "E",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "Full time",
				"value": "F"
			},
			{
				"name": "Home Business",
				"value": "H"
			},
			{
				"name": "Part time",
				"value": "P"
			},
			{
				"name": "Seasonal",
				"value": "S"
			}
		],
		"customFields": [
			{
				"fieldType": "text",
				"id": "employer",
				"name": "creditAssessment.employer",
				"label": "Employer",
				"placeholder": "Tell us who your current employer is",
				"autotestClass": "auto-test-employer",
				"maxLength": 100,
				"isRequired": true,
				"required": true
			},
			{
				"fieldType": "month-year",
				"id": "date-started-current",
				"name": "creditAssessment.dateStartedCurrent",
				"label": "Date you started work with your current employer",
				"autoTestClass": "auto-test-date-started-current",
				"isRequired": true,
				"required": true
			},
			{
				"fieldType": "text",
				"id": "previousEmployer",
				"name": "creditAssessment.previousEmployer",
				"label": "Previous employer's name",
				"placeholder": "Tell us who your previous employer was",
				"autotestClass": "auto-test-previous-employer",
				"maxLength": 100
			},
			{
				"fieldType": "month-year",
				"id": "date-started-previous",
				"name": "creditAssessment.dateStartedPrevious",
				"label": "Date you started work at your previous employer",
				"autoTestClass": "auto-test-date-started-current"
			}
		]
	},
	{
		"id": "employment-home-exec",
		"name": "Home executive",
		"value": "H",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "Full time",
				"value": "F"
			},
			{
				"name": "Part time",
				"value": "P"
			},
			{
				"name": "Unemployed",
				"value": "U"
			}
		]
	},
	{
		"id": "employment-student",
		"name": "Student",
		"value": "P",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "Full time",
				"value": "F"
			},
			{
				"name": "Part time",
				"value": "P"
			},
			{
				"name": "Seasonal",
				"value": "S"
			},
			{
				"name": "Unemployed",
				"value": "U"
			}
		]
	},
	{
		"id": "employment-retired",
		"name": "Retired",
		"value": "R",
		"subCategories": []
	},
	{
		"id": "employment-self-employed",
		"name": "Self-employed",
		"value": "S",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "Full time",
				"value": "F"
			},
			{
				"name": "Home Business",
				"value": "H"
			},
			{
				"name": "Seasonal",
				"value": "S"
			}
		]
	},
	{
		"id": "employment-benefit",
		"name": "Benefit",
		"value": "B",
		"subCategories": [
			{
				"name": "Unemployed",
				"value": "U"
			}
		]
	},
	{
		"id": "employment-superann",
		"name": "Superannuitant",
		"value": "T",
		"subCategories": [
			{
				"name": "Unemployed",
				"value": "U"
			}
		]
	},
	{
		"id": "employment-unemployed",
		"name": "Unemployed",
		"value": "U",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "Seasonal",
				"value": "S"
			},
			{
				"name": "Unemployed",
				"value": "U"
			}
		]
	},
	{
		"id": "employment-not-saying",
		"name": "Not willing to supply",
		"value": "Z",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "Full time",
				"value": "F"
			},
			{
				"name": "Home Business",
				"value": "H"
			},
			{
				"name": "Part time",
				"value": "P"
			},
			{
				"name": "Seasonal",
				"value": "S"
			},
			{
				"name": "Unemployed",
				"value": "U"
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/checkout/CreditAssessmentStep2/CAOccupation.json
 ** module id = 480
 ** module chunks = 0
 **/